<template>
  <div class="bto-sb-element">
    <!-- if event is replay-->
    <object v-if="replayTracker" :data="replayTracker" class="bto-sb-replaytracker">
      <embed :src="replayTracker" class="bto-sb-replaytracker" />
    </object>
    <div
      v-if="checkProvider(BETRADAR) || checkProvider(BETRADAR_V3)"
      :id="betradarContainerId"></div>
    <div
      v-if="checkProvider(STATSCORE) && !statscoreError"
      class="STATSCORE__Tracker"
      :id="`Tracker-${betRadarId}`"
      :data-event="betRadarId"
      :data-lang="statscoreLang"
      :data-config="statscoreConfigId"
      data-zone=""
      data-use-mapped-id="1"></div>
    <div v-if="checkProvider(STATSCORE_V3) && !statscoreError" ref="trackerEl"></div>
    <iframe
      scrolling="no"
      v-if="checkProvider(BETGENIUS) && getBsportsTrackerData.feedProvider === 'bg'"
      id="betgenius-iframe"
      :src="betgeniusUrlIframe"
      width="100%"
      :height="iframeHeight"
      frameBorder="0"></iframe>
    <bsports-tracker
      v-else-if="checkProvider(BSPORTS) || statscoreError || (checkProvider(BETGENIUS) && getBsportsTrackerData.feedProvider != 'bg')"
      :matchDetails="getBsportsTrackerData" :liveStatistics="getBsportsStatisticsData"/>
  </div>
</template>

<script>
  import store from '@/store';
  import { TRACKING_PROVIDERS } from '../../../models/trackers';
  import BsportsTracker from '../bsports-tracker_new/bsports-tracker';
  import { fetchResource } from '../../../services/utils';
  const { STATSCORE, BETRADAR, BSPORTS, BETRADAR_V3, STATSCORE_V3, BETGENIUS } = TRACKING_PROVIDERS;
  const betradarV3FnName = "SIR";

  const defaultV3Themes = {
    neutral: 'neutral',
    betradar: 'betradar',
    betradardark: 'betradardark',
    sportradar: 'sportradar',
    sportradardark: 'sportradardark',
  };

  export default {
    name: 'LiveTrackerComponent',
    components: { BsportsTracker },
    data() {
      return {
        STATSCORE,
        BETRADAR,
        BSPORTS,
        BETRADAR_V3,
        STATSCORE_V3,
        BETGENIUS,
        provider: APP_SETTINGS.liveTracker.provider,
        statscoreLang: this.$root.statscoreLang,
        statscoreConfigId: APP_SETTINGS.liveTracker.statscoreConfigId,
        betradarContainerId: 'bto-sb-live-tracker',
        statscoreError: false,
        liveTrackerId: null,
        replayTournaments: APP_SETTINGS.liveTracker.replayTournaments || '',
        replayKey: APP_SETTINGS.liveTracker.replayKey || '',
        replayTracker: '',
        st3Widget: null,
        betgeniusUrlIframe: '',
        iframeHeight: '',
      };
    },
    props: {
      betRadarId: {
        type: Number,
        required: true,
        default: 0,
      },
      tournamentId: {
        type: Number,
        default: 0,
      },
      tournamentName: {
        type: String,
        default: '',
      },
      isAwayAtHome: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      getBsportsTrackerData() {
        return store.getters.getBsportsTrackerData;
      },
      getBsportsStatisticsData() {
        // return null;
        return store.getters.getBsportsStatisticsData;
      },
    },
    mounted() {
      // check if event is replay
      if (this.replayTournaments !== '' && this.replayKey !== '') {
        const tids = this.replayTournaments.trim().split(/\s*,\s*/);
        if (tids.includes(this.tournamentId.toString()) ||
          (this.tournamentName !== '' && tids.includes(this.tournamentName))
        ) {
          const url = 'https://cdn.lsports.eu/Widgets/PlayByPlay';
          const isVirt = typeof APP_SETTINGS.liveTracker.lVisionVirtual !== 'undefined'
            ? APP_SETTINGS.liveTracker.lVisionVirtual
            : true;
          this.replayTracker = `${url}?eventId=${this.betRadarId}&apiKey=${this.replayKey}&virtual=${isVirt}&language=${APP_SETTINGS.player.language}`;
          return;
        }
      }

      // If we don't have replay tracker active, setup tracker set in this.provider
      this.setupTrackers();
    },
    methods: {
      /**
       * Get and initialize live tracker based on set provider
       */
      setupTrackers() {
        switch (this.provider) {
          case BETRADAR:
            this.setupBetradar();
            return;
          case BETRADAR_V3:
            this.setupBetradarV3();
            return;
          case STATSCORE:
            this.setupStatscore();
            return;
          case STATSCORE_V3:
            this.setupStatscoreV3();
            return;
          case BETGENIUS:
            this.setupBetgenius();
            return;
          case BSPORTS:
            return;
          default:
            console.error('no provider set for live tracker'); // eslint-disable-line
            return;
        }
      },
      /**
       * Get statscore script if not preset,then initalize the live tracker
       */
      setupStatscore() {
        const statscoreUrl = 'https://live.statscore.com/livescorepro/generator';
        fetchResource('script', 'bto-sb-lmt-st', { async: true, src: statscoreUrl }).then(this.initStatscore);
      },
      setupStatscoreV3() {
        const statscoreV3Url = 'https://wgt-s3-cdn.statscore.com/bundle/Embeder.js';
        fetchResource('script', 'bto-statscore-v3', { async: true, src: statscoreV3Url }).then(this.initStatscoreV3);
      },
      /**
       * Initalize statscore live tracker
       */
      initStatscore() {
        // Script for statscore is not present exit
        if (typeof window['Softnetsport'] === 'undefined') {
          return;
        }
        if (typeof this.$root.statscore !== 'object' || Object.keys(this.$root.statscore).length === 0) {
          this.$root.statscore = new window.Softnetsport.LSP.Generator();
        }
        window.addEventListener('message', this.statscoreErrorHandler);
        // init statscore live tracker
        this.$root.statscore.addTrackersEmbeddedOnPage();
      },
      initStatscoreV3() {
        // If script is not initialized load default values on window object
        if (!window.STATSCOREWidgets) {
          window.STATSCOREWidgets = {};
          window.STATSCOREWidgets.onLoadCallbacks = [];
          window.STATSCOREWidgets.onLoad = function (d) {
            window.STATSCOREWidgets.onLoadCallbacks.push(d);
          };
        }

        window.STATSCOREWidgets.onLoad(err => {
          if (err) {
            this.statscoreError = true;
            return;
          }

          const element = this.$refs.trackerEl;

          // Configuration that you should receive from STATSCORE
          const configurationId = APP_SETTINGS.liveTracker.statscoreConfigId;

          // Feed Provider Codes
          // Betgenius 'bg' - 109
          // Betradar 'sr' - 11
          const providerCode = this.getBsportsTrackerData.feedProvider === 'bg' ? 109 : 11;

          //Language Code
          const language = window.sportCastCulture == 'pt-BR' ? 'br' : APP_SETTINGS.player.language

          // Input data for widget type you want to embded
          const inputData = { eventId: `m:${this.betRadarId}`, providerId: providerCode, language: language, invertedParticipants: this.isAwayAtHome };

          // Optional object with options.
          // You can check available options further in the docs.
          const options = { loader: { enabled: true } };

          this.st3Widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
          this.st3Widget.on('error', () => {
            this.statscoreError = true;
          });
        });
      },
      /**
       * Get betradar script if not present,then initalize the live tracker
       */
      setupBetradar() {
        let brClient = APP_SETTINGS.liveTracker.brliveclient;
        let lang = APP_SETTINGS.player.language;

        let liveTrackerUrl = `//cs.betradar.com/ls/widgets/?/${brClient}/${lang}/widgetloader/widgets`;
        fetchResource('script', 'bto-sb-lmt-br', { async: true, src: liveTrackerUrl }).then(this.initBetradar);
      },
      /**
       * Initalize betradar live tracker
       */
      initBetradar() {
        // Script for betradar is not present exit
        if (typeof SRLive === 'undefined') {
          return;
        }
        let timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone.replace('/', ':');
        if (typeof timeZoneName === 'undefined' || timeZoneName === '') {
          timeZoneName = 'Europe:Berlin';
        }
        setTimeout(() => {
          SRLive.changeTimezone(timeZoneName);
          this.liveTrackerId = SRLive.addWidget({
            widget: {
              applyIEClass: true,
              rootRewritten: false,
              hostMapped: false,
            },
            name: 'widgets.lmts',
            config: {
              container: `#${this.betradarContainerId}`,
              matchId: this.betRadarId,
              collapse_startCollapsed: APP_SETTINGS.liveTracker.startCollapsed || false,
            },
          });
        });
      },
      /**
       * Get betradarV3 script if not present,then initalize the live tracker
       */
      setupBetradarV3() {
        if (!window[betradarV3FnName]) {
          // use this to queue function calls which will be executed once script loads
          let locSIR = window[betradarV3FnName] = function () {
            (window[betradarV3FnName].q = window[betradarV3FnName].q || []).push(arguments);
          };
          locSIR.l = 1 * new Date;
          // Options object passed to betradar script
          locSIR.o = {
            language: APP_SETTINGS.player.language,
            theme: defaultV3Themes[APP_SETTINGS.liveTracker.V3Theme] || false,
          };
        }
        let brClient = APP_SETTINGS.liveTracker.brliveclient;

        let liveTrackerUrl = `//widgets.sir.sportradar.com/${brClient}/widgetloader`;
        fetchResource('script', 'bto-sb-lmt-br3', { async: true, src: liveTrackerUrl, n: betradarV3FnName })
          .then(this.initBetRadarV3);
        this.getBetradarV3Theme();
      },
      getBetradarV3Theme() {
        if (APP_SETTINGS.liveTracker.provider === BETRADAR_V3 &&
          APP_SETTINGS.liveTracker.V3Theme &&
          !defaultV3Themes[APP_SETTINGS.liveTracker.V3Theme]) {
          const baseUrl = APP_SETTINGS.path.baseUrl;
          const url = `${baseUrl}betradar-themes/${APP_SETTINGS.liveTracker.V3Theme}.css`;
          fetchResource('link', 'lmt3-custom-theme', { href: url, rel: 'stylesheet' });
        }
      },
      /**
       * Initalize betradarV3 live tracker
       */
      initBetRadarV3() {
        const locSir = window[betradarV3FnName];
        const lmtWidget = APP_SETTINGS.liveTracker.V3Widget || 'match.lmtPlus';
        locSir('addWidget', `#${this.betradarContainerId}`, lmtWidget, {
          // disableWidgetHeader: false, // When set to true, hides widget header
          layout: APP_SETTINGS.liveTracker.V3Layout || "single", // Determines type of layout. Valid values are single, double, topdown
          disableComponents: APP_SETTINGS.liveTracker.V3DisableComponents || false, // When set to true, disables components part of widget when layout type is set to single
          // disablePitch: true, // When set to true, hides pitch and fixes layout type to single
          momentum: APP_SETTINGS.liveTracker.V3Momentum || "compact", // Determines type of momentum. Valid values are disable, compact,bars, line, timeline
          scoreboard: APP_SETTINGS.liveTracker.V3Scoreboard || "compact", // Determines type of scoreboard. Valid values are disable, extended, compact
          collapseTo: APP_SETTINGS.liveTracker.V3CollapseTo || "disable", // Determines inital collapse states. Valid values are disable, scoreboard, momentum, pitch
          expanded: !APP_SETTINGS.liveTracker.startCollapsed, // When set to true, the collapsed components will be initially expanded
          tabsPosition: APP_SETTINGS.liveTracker.V3TabsPosition || "bottom", // Determines position and display of navigation. Valid values are top, bottom, disable
          detailedScoreboard: APP_SETTINGS.liveTracker.V3DetailedScoreboard || "all", // Defines the content shown for subheader. Valid values are all, momentum, scoreDetails, disable
          activeSwitcher: APP_SETTINGS.liveTracker.V3ActiveSwitcher || "scoreDetails", // Defines the default shown item in the subheader switcher. Valid values are momentum, scoreDetails 
          matchId: this.betRadarId,
        });
      },
      /* Setup betgenius live tracker */
      setupBetgenius() {
        const culture = window.sportCastCulture || APP_SETTINGS.player.language;
        const betgeniusUrl = APP_SETTINGS.liveTracker.betgeniusUrl;
        this.betgeniusUrlIframe = `${betgeniusUrl}/${this.getBetgeniusWidget()}?eventId=${this.betRadarId}&locale=${culture}`;
      },
      /* Generate BetGenius Widget Name by sport type */
      getBetgeniusWidget() {
        const sportClass = store.getters.getSportClass(this.getBsportsTrackerData.sportId);
        if (sportClass !== 'soccer' && sportClass !== 'basketball' && sportClass !== 'tennis') {
          this.iframeHeight = "72px";
          return 'multisportscoreboard';
        }
        this.iframeHeight = "294px";
        if (sportClass === 'soccer') {
          return 'footballscorecentre';
        }
        return `${sportClass}scorecentre`;
      },
      /**
       * Check if given provider is the active provider
       * @param {string} provider - Provider to check
       */
      checkProvider(provider) {
        return !this.replayTracker && this.provider === provider;
      },
      statscoreErrorHandler(event) {
        if (event.origin !== 'https://live.statscore.com') {
          return;
        }
        if (event.data.type === 'statscore.livematchpro.error') {
          this.statscoreError = true;
        }
      },
      removeStatscoreErrorListener() {
        window.removeEventListener('message', this.statscoreErrorHandler);
      },
    },
    beforeDestroy() {
      if (this.provider === STATSCORE_V3 && this.st3Widget) {
        this.st3Widget.destroy();
        this.st3Widget = null;
      }
      if (this.provider === STATSCORE) {
        this.removeStatscoreErrorListener();
      }
      if (this.provider === BETRADAR_V3) {
        const locSir = window[betradarV3FnName];
        locSir('removeWidget', `#${this.betradarContainerId}`);
      }
      if (typeof SRLive !== 'undefined') {
        SRLive.removeWidget(this.liveTrackerId);
      }
    },
  };
</script>
